import type { Distance, Pixel } from "@pdfking/math"
import type { HorizontalAlign } from "../align/HorizontalAlign"
import type { VerticalAlign } from "../align/VerticalAlign"
import type { ColorMap } from "./ColorMap"

export type PlottingContext<T> = {
  readonly color_map: ColorMap
  readonly file_map: Record<string, T>
  readonly font_family: string
  readonly font_size: Pixel
  readonly horizontal_align: HorizontalAlign
  readonly image_dpi: Pixel
  readonly page_bleed: Distance
  readonly stroke_width: Distance
  readonly unit_to_px: number
  readonly vertical_align: VerticalAlign
}
